/* eslint-disable no-case-declarations */
/* eslint-disable no-mixed-operators, dot-notation */
/* eslint-disable line-comment-position,no-inline-comments,multiline-comment-style */
/* eslint-disable no-multi-assign, no-undef, one-var */
/* eslint-disable prefer-destructuring, @typescript-eslint/no-empty-function */
/*
 * @Author: xdx
 * @Date: 2022-11-16
 * 封装高德地图 常用方法
 */
import moment from 'moment';
import {
  setFeatureThresholdInfo, setFeatureThresholdInfoStatic, setClusterFeature, setMarkerrFeature,
} from '../thresholdInfo';
import { icons, updateIconsConfig,colorMap, } from './icons';
import CoorsOffset from '@/utils/coordinateConversions';
import { geoserverIp, } from '@/configs/index';
import { Observed, Watch, } from '@/utils/event';
import { message, } from 'ant-design-vue';

/**
 * @param {string} domId 容器id
 * @param {number[]} center 中心点
 * @param {number} zoom 等级
 * @param {string} style 底图风格
 */
export default class GDMap extends AMap.Map {
  constructor (
    domId: string,
    center: number[],
    zoom: number,
    zooms: number[],
    viewMode: string,
    moveCallback?: any,
    moveStartCallback?: any
  ) {
    super(domId, {
      key: 'd79ff396531b948ce14d5be1c733fc36',
      center,
      zoom,
      zooms,
      // 要用掩膜就必须得用3d模式
      viewMode,
      resizeEnable: true,
    });

    this.initConfig();

    // 卫星图层
    this.sateLayer = {};
    // 路况图层
    this.roadNetLayer = {};
    // 节点图层
    this.lablesLayer = {};
    // 节点图层Markers数据缓存
    this.lableMarkers = {
      cookingFume: [],
      construction: [],
      company: [],

      /*
       * country: [],
       * province: [],
       * city: [],
       * micro: [],
       */
    };
    // 图片图层
    this.imageLayer = {};
    // 图片图层数据缓存
    this.img_layers_list = [];
    // 聚合图层
    this.clusterLayer = {
      country: {},
      province: {},
      city: {},
      micro: {},
      cookingFume: {},
      construction: {},
      company: {},
      cookingFumeList: {},
      constructionList: {},
      companyList: {},
      parkList: {},
      muckParkList: {},
      park: {},
      repairList: {},
      repair: {},
      pre: {},
      prs: {},
      rhu: {},
      tem: {},
      satellitePoint: {},
      monitorPoint: {},
      // 工单mark点位
      strokePoint: {},
      boiler: {},
      furnace: {},
      boilerList: {},
      furnaceList: {},
      oilList: {},
    };
    // 临时点位
    this.tempMarker = {
      animationMarker: {}, // 移动点位 移动结束后会被删除
      marker: {}, // 固定点位
      lnglatAddress: {}, // 当前点位经纬度与位置信息
      observedInstance: new Observed(), // 临时点位的实例对象
    };

    // 选中站点
    this.selectedStation = {
      id: '',
      marker: null,
      contentHTml: '',
    };
    // 风场图层
    this.WindLayer = {};
    // 轨迹图层
    this.trackLablesLayer = {};
    // 轨迹图层Markers数据缓存
    this.trackLableMarkers = {
      muckTrack: { car: {}, track: {}, },
      fogGunTrack: { car: {}, track: {}, },
      wateringTrack: { car: {}, track: {}, },
      sweeperTruck: { car: {}, track: {}, },
      moveTrack: { car: {}, track: {}, showCar: '', },
    };
    // wms图层
    this.wmsLayer = {
      gaochunCounty: {},
    };

    // 热点网格
    this.gridOverlayGroups = {};
    this.rectangles = [];
    // 扇形图层
    this.sectorLayer = {};

    // 溯源图层
    this.traceLayer = {
      small: {},
      middle: {},
      large: {},
    };
    this.traceMarkers = [];

    this.context = {};
    this.canvaimg = {};

    // 工具栏实例
    this.mouseTool = null;
    this.imageOpacity = 0.6;

    // 直线端点
    this.linePoint = [];
    // 直线端点marker
    this.lineMarker = [];
    // 临时的距离文本
    this.tmpLineText = null;
    // 是否重新生成临时距离文本
    this.addLineTextFlag = false;
    // 存储每一次点击测距生成的key
    this.keyMap = [];
    // 存储测距产生的元素
    this.tmpElementsMap = new Map();

    // 保存弹窗实例
    this.infoWin = null;
    this.on('movestart', moveStartCallback);
    this.on('moveend', moveCallback);
    this.on('zoomstart', moveStartCallback);
    this.on('zoomend', moveCallback);
  }

  // 根据用户数据 初始化空气站地图图标配置
 initConfig = () : void => {
   const pmIconsConfig = JSON.parse(localStorage.getItem('pmIconsConfig') || '{}');

   Object.keys(pmIconsConfig).forEach((key) => {
     updateIconsConfig(key,pmIconsConfig[key].type);
   });
 }

  destroyMap = (): void => {
    this.destroy();
  };

  /**
   * 高德地图添加边界
   * @param {string} area 地区名
   * @returns {void}
   */
  setRegionPolygonByArea = (area: string): void => {
    if (area === '高淳区') {
      this.addWmsLayer('air:gaochun_county', 'gaochunCounty');
    } else {
      AMap.plugin(['AMap.DistrictSearch',], () => {
        new AMap.DistrictSearch({
          extensions: 'all',
          subdistrict: 0,
        }).search(area, (status: any, result: any) => {
          // 外多边形坐标数组
          const outer = [
            new AMap.LngLat(-360, 90, true),
            new AMap.LngLat(-360, -90, true),
            new AMap.LngLat(360, -90, true),
            new AMap.LngLat(360, 90, true),
          ];

          // 内多边形坐标数组
          const bounds = result.districtList[0].boundaries;

          const pathArray = [outer,];

          if (bounds && bounds.length) {
            // 构造MultiPolygon的path
            pathArray.push(...bounds);
            // 生成行政区划polygon
            const polygon = new AMap.Polygon({
              path: pathArray,
              strokeColor: '#eb5d5f',
              strokeWeight: 2,
              fillColor: '#151B28',
              fillOpacity: 0.1,
              bubble: true, // 将覆盖物的鼠标或touch等事件冒泡到地图上
            });

            this.add(polygon);
          }
        });
      });
    }
  };

  // 设置焦作边界
  setJiaoZuoPolygonByArea = (area:any):void => {
    const flatArray = area.features[0].geometry.coordinates.flat()[0].map(([lng, lat,]: any) => new AMap.LngLat(lng, lat, true));

    const outer = [
      new AMap.LngLat(-360, 90, true),
      new AMap.LngLat(-360, -90, true),
      new AMap.LngLat(360, -90, true),
      new AMap.LngLat(360, 90, true),
    ];

    const pathArray = [
      outer,
    ];

    pathArray.push(flatArray);
    const polygon = new AMap.Polygon({
      pathL: pathArray,
      strokeColor: '#eb5d5f',
      strokeWeight: 2,
      fillColor: '#151B28',
      fillOpacity: 0.1,
    });

    polygon.setPath(pathArray);
    this.add(polygon);
  };

  // 地图展示地图影像
  sateLayerShow = (): void => {
    this.sateLayer = new AMap.TileLayer.Satellite();
    this.roadNetLayer = new AMap.TileLayer.RoadNet();
    // 批量添加图层
    this.add([this.sateLayer, this.roadNetLayer,]);
  };

  // 地图删除地图影像
  sateLayerRemove = (): void => {
    this.remove(this.sateLayer);
    this.remove(this.roadNetLayer);

    /*
     *  this.removeLayer(this.sateLayer);
     * this.removeLayer(this.roadNetLayer);
     */
    this.sateLayer = {};
    this.roadNetLayer = {};
  };

  /**
   * 高德地图添加边界
   * @param {string} type
   * sate 影像
   * vector 矢量
   * darkVector 深色矢量
   * @returns {void}
   */
  changeMapStyle = (type: string): void => {
    switch (type) {
    case 'sate':
      this.sateLayerShow();
      break;
    case 'vector':
      this.sateLayerRemove();
      // this.setMapStyle('amap://styles/53fb619e41a7a9901cdfdcb45e28da5a');
      this.setMapStyle('amap://styles/macaron');
      break;
    case 'darkVector':
      this.sateLayerRemove();
      this.setMapStyle('amap://styles/8b0178f690978b80436e83dbef7b0402');
      break;
    default:
      this.setMapStyle('amap://styles/8b0178f690978b80436e83dbef7b0402');
      break;
    }
  };

  // 添加标记图层
  addLabelsLayer = (): void => {
    this.lablesLayer = new AMap.LabelsLayer({
      zooms: [3, 20,],
      zIndex: 1000,
      collision: false,
    });
    this.add(this.lablesLayer);
    this.lableMarkers = {
      cookingFume: [],
      construction: [],
      company: [],
    };
  };

  // 地图清除标记图标
  clearLabelsLayer = (): void => {
    if (this.lablesLayer) {
      this.lablesLayer.clear();
    }
  };

  // 地图删除LabelsLayer图层
  removeLabelsLayer = (): void => {
    if (Object.keys(this.lablesLayer).length) {
      this.remove(this.lablesLayer);
      // this.removeLayer(this.lablesLayer);
      this.lablesLayer = {};
      this.lableMarkers = {
        cookingFume: [],
        construction: [],
        company: [],
      };
    }
  };

  getLayersAll = (): void => {
    const layers: any = this.getLayers();
  };

  /**
   * 筛选可视区点列表
   * @param {any[]} allList 全部站点列表数据
   * @return {any[]} screenHouseList 可视区站点列表数据
   */
  filterListByScreenViews = (allList: any): any => {
    if (allList) {
      const screenCoordinateRange = this.getBounds();
      const northEast = [screenCoordinateRange?.northEast?.lng, screenCoordinateRange?.northEast?.lat,];
      const southEast = [screenCoordinateRange?.southWest?.lng, screenCoordinateRange?.northEast?.lat,];
      const southWest = [screenCoordinateRange?.southWest?.lng, screenCoordinateRange?.southWest?.lat,];
      const northWest = [screenCoordinateRange?.northEast?.lng, screenCoordinateRange?.southWest?.lat,];

      const screenHouseList = allList.filter((item: any) => {
        const { lon, lat, } = item;

        if (northEast && southEast && southWest && northWest && lon && lat) {
          return AMap.GeometryUtil.isPointInRing(
            [lon, lat,],
            [northEast,
              southEast,
              southWest,
              northWest,]
          );
        }

        return false;
      });

      return screenHouseList;
    }

    return [];
  };

  /**
   * 绘制标记
   * @param {any[]} elementParam 要素信息
   * @param {any} marksInfo 站点集合
   * * @param {any} nodeType 站点类型
   * * @param {any} clickCallback 点击站点回调函数
   * @return {void}
   */
  showMakersByLabelsLayer = (elementParam: any,marksInfo: any, nodeType: string,clickCallback?: any) => {
    // 要素类型
    const elementType = elementParam.value.type.toLowerCase();
    const markers: any[] = [];

    this.lableMarkers[nodeType] = [];

    /*
     * 初始化 labelMarker
     */
    marksInfo.forEach((markInfo: any, index: number) => {
      // eslint-disable-next-line multiline-ternary
      const pos: any[] = [markInfo.lon, markInfo.lat,];

      // eslint-disable-next-line multiline-ternary
      const name = markInfo.pointName ? markInfo.pointName : markInfo.name;

      const markFeature = setFeatureThresholdInfo(markInfo[elementType], elementType);
      // eslint-disable-next-line multiline-ternary
      const image = markInfo.status ? setFeatureThresholdInfoStatic(markInfo.status) : markFeature.emo;

      const labelMarkerIcon = new AMap.LabelMarker({
        name,
        position: pos,
        zooms: [1, 20,],
        opacity: 1,
        zIndex: 1000,
        text: {
          // eslint-disable-next-line multiline-ternary
          content: markInfo[elementType] ? markInfo[elementType] : '',
          direction: 'center',
          style: {
            fontSize: 14,
            fontWeight: 'bold',
            // 没有颜色需求，直接写'rgb(68, 67, 0)'
            fillColor: markFeature.fontColor,
            padding: [3, 10,],
            borderColor: 'rgba(255,255,255, 0)',
            borderWidth: 1,
            // backgroundColor: 'red',
          },
        },
        icon: {
          // 图标类型，现阶段只支持 image 类型
          type: 'image',
          // image: icons[nodeType][markFeature.emo] ,
          image: icons[nodeType][image],
          size: icons[nodeType].iconSize,
        },
      });

      labelMarkerIcon.on('click', (e: any) => {
        const position = e.lnglat;

        // clickCallback(markInfo,nodeType,lnglat);
        clickCallback({ ...markInfo, position, }, nodeType);
      });

      const labelMarkerText = new AMap.LabelMarker({
        name,
        position: pos,
        zooms: [1, 20,],
        opacity: 1,
        zIndex: 10,
        text: {
          content: name,
          offset: [0, 25,],
          style: {
            fontSize: 14,
            fillColor: '#b5b3b3',
            padding: [3, 10,],
            borderColor: 'rgba(255,255,255, 0)',
            borderWidth: 1,
          },
        },
      });

      markers.push(labelMarkerIcon);
      markers.push(labelMarkerText);
    });
    this.lableMarkers[nodeType] = markers;
    // 将 marker 添加到图层
    this.lablesLayer.add(this.lableMarkers[nodeType]);
  };

  /*
   *  隐藏或隐藏labelMakers
   * labelType:labelMake的类型
   * handleType:操作类型  hide remove
   */
  labelMarkerHideOrRemove = (labelType: string, handleType: string) => {
    const lableMarkerArr = this.lableMarkers[labelType];

    if (lableMarkerArr.length === 0) {
      return;
    }
    switch (handleType) {
    case 'hide':
      lableMarkerArr.forEach((mark: any) => {
        mark.hide();
      });
      break;
    case 'remove':
      lableMarkerArr.forEach((mark: any) => {
        mark.remove();
      });
      this.lableMarkers[labelType] = [];
      break;
    default:
      break;
    }
  };

  /*
   *  显示labelMakers
   *  labelType:labelMake的类型
   */
  labelMarkerShow = (labelType: string) => {
    const lableMarkerArr = this.lableMarkers[labelType];

    lableMarkerArr.forEach((mark: any) => {
      mark.show();
    });
  };

  // 清除聚合图层
  clearMarkerClusterer = (type: string) => {
    if (type === 'all') {
      Object.keys(this.clusterLayer).forEach((key) => {
        if (Object.keys(this.clusterLayer[key]).length !== 0) {
          this.clusterLayer[key].setMap(null);
          this.clusterLayer[key] = {};
        }
      });
    } else if (this.clusterLayer[type] && Object.keys(this.clusterLayer[type]).length !== 0) {
      this.clusterLayer[type].setMap(null);
      this.clusterLayer[type] = {};
    }
  };

  /**
   * 展示聚合节点数据
   * @param {any} elementParam 要素类型
   * @param {any} marksInfo 点数据
   * @param {string} nodeType 图层类型
   * @param {boolean} isClusterer 是否聚合
   * @param {any} clickCallback 回调函数
   * @param {string} idChangeTo id转换：id非站点标识时需要转换字段(暂时仅气象站点)
   * @return {void}
   */
  showMarkerClusterer = (elementParam: any,marksInfo: any,nodeType: string, isClusterer: boolean,clickCallback?: any,idChangeTo = 'id') => {
    // 要素类型
    const elementType = elementParam.value.type.toLowerCase();
    const points: any[] = [];
    let count = 0;

    // 初始化 labelMarker
    marksInfo.forEach((markInfo: any, index: number) => {
      const pos = [markInfo.lon, markInfo.lat,];
      const { text, emo, } = setMarkerrFeature(nodeType, markInfo, elementType);
      let image = ''; // marker图片

      image = icons[nodeType][emo];
      const name = markInfo.name ? markInfo.name : '';

      points.push({
        lnglat: pos,
        value: text,
        image,
        pointName: name,
        markInfo,
        extData: { id: nodeType + name + markInfo[idChangeTo] ?? '', },
      });
    });

    // eslint-disable-next-line no-underscore-dangle
    const _renderMarker = (context: any) => {
      const isChecked = context.data[0]?.extData.id === this.selectedStation.id;
      const curZoom = this.getZoom();
      const iconSize = icons[nodeType].iconSize ?? [40,40,];
      const zoomSize = icons[nodeType].zoomSize ?? 12;
      const fontColor = icons[nodeType].fontColor ?? '#78d5fc';
      const strokeColor = icons[nodeType].strokeColor ?? '#124dc3';
      const topOffset = icons[nodeType].topOffset ?? '0';
      const valueColor = icons[nodeType].valueColor ?? '';
      const nameHtml = `<div style="font-size:14px;line-height:14px;font-weight:700;color: ${fontColor};height: 40px; width: 100px; text-shadow: 0 1px ${strokeColor}, 1px 0 ${strokeColor}, -1px 0 ${strokeColor}, 0 -1px ${strokeColor};">${context.data[0]?.pointName}</div>`;
      const checkedHtml = `<div style="position:absolute;border:2px solid red;border-radius:100%;top:50%;left:50%;transform:translate(-50%,-50%);height:50%;width:150%;margin-top:${topOffset}"></div>`;
      const showNameHtml = curZoom >= zoomSize ? nameHtml : '';
      const content = `<div><div style="z-index:30;margin:auto;position:relative;text-align:center;background-image: url(${context.data[0]?.image});background-size: 100% 100%;background-repeat: no-repeat;font-size:14px;line-height:${iconSize[1]}px;color:${valueColor}; height: ${iconSize[1]}px; width: ${iconSize[0]}px; padding-top:${topOffset}">${context.data[0]?.value}</div>${showNameHtml}</div>`;
      // const offset = new AMap.Pixel(-50, -40);
      const offset = new AMap.Pixel(0, 0);
      // <span class="item_count">1</span>
      const contentHigh = `<div><div class="markerClass"style="background-image: url(${context.data[0]?.image});background-size: 100% 100%;background-repeat: no-repeat;font-size:14px;line-height:${iconSize[1]}px;color:${valueColor}; height: ${iconSize[1]}px; width: ${iconSize[0]}px; padding-top:${topOffset}">${context.data[0]?.value}</div>${showNameHtml}</div>
        <div class="circle-marker-content" style='padding-top:${topOffset};'>
        <div class="item item1" style='height:40px;width:40px;'></div>
        <div class="item item2" style='height:50px;width:50px;'></div>
        <div class="item item3" style='height:55px;width:55px;'></div>
        <div class="item item4" style='height:60px;width:60px;'></div>
        <div class="item item5" style='height:70px;width:70px;'></div>
        <div class="item item6" style='height:80px;width:80px;'></div>
      </div>`;

      // eslint-disable-next-line no-param-reassign
      context.marker.id = context.data[0]?.extData.id;
      context.marker.setOffset(offset);
      context.marker.setAnchor('center');

      // 根据类型展示节点图标  重新渲染时有高亮,渲染高亮效果
      if (isChecked) {
        context.marker.setzIndex(20);
        context.marker.setContent(contentHigh);
      } else {
        context.marker.setzIndex(0);
        context.marker.setContent(content);
      }

      // 设置渲染节点信息
      if (isChecked) {
        this.selectedStation.marker = context.marker;
        this.selectedStation.contentHTml = content;
      }
      // 点击节点 高亮渲染
      context.marker.on('click', (e: any,...tmp:any) => {
        const { extData,markInfo, lnglat, } = context.data[0];

        // 对已存在高亮节点进行huang
        if (this.selectedStation.marker) {
          this.selectedStation.marker.setzIndex(20);
          this.selectedStation.marker.setContent(this.selectedStation.contentHTml);
        }

        markInfo.position = lnglat;
        context.marker.setzIndex(20);
        context.marker.setContent(contentHigh);

        /*
         * context.marker.setAnimation('AMAP_ANIMATION_BOUNCE');
         * 缓存当前选中的marker数据
         */
        this.selectedStation.marker = context.marker;
        this.selectedStation.contentHTml = content;
        this.selectedStation.id = extData.id;
        clickCallback(markInfo, nodeType);
      });
    };

    // eslint-disable-next-line no-underscore-dangle
    const _renderClusterMarker = (context: any) => {
      const { text: inHtmlText,emo, } = setClusterFeature(nodeType,context.count,context.clusterData,elementType);

      count = points.length;
      const div = document.createElement('div');

      const size = Math.round(30 + (context.count / count) ** (1 / 5) * 20);

      div.style.width = div.style.height = `${size}px`;
      div.innerHTML = inHtmlText;

      div.style.lineHeight = `${size}px`;
      div.style.color = '#000';
      div.style.fontSize = '14px';
      div.style.textAlign = 'center';
      div.style.textAlign = 'center';

      // eslint-disable-next-line camelcase, multiline-ternary
      const icon_str = inHtmlText === '-' ? 'nodata' : emo;

      div.style.backgroundImage = `url(${icons.cluster[icon_str]})`;
      div.style.backgroundSize = '100% 100%';
      div.style.backgroundRepeat = 'no-repeat';
      context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
      context.marker.setContent(div);

      context.marker.on('click', (e: any) => {
        const curZoom = this.getZoom();
        const nextZoom = curZoom + 2;

        this.setZoomAndCenter(nextZoom, e.lnglat);
      });
    };

    this.plugin(['AMap.MarkerClusterer',], () => {
      this.clusterLayer[nodeType] = new AMap.MarkerClusterer(this, points, {
        gridSize: 60,
        // eslint-disable-next-line multiline-ternary
        maxZoom: isClusterer ? 30 : 2,
        renderClusterMarker: _renderClusterMarker,
        renderMarker: _renderMarker,
        isClusterer,
      });
    });
  };

  /**
   *添加图片图层
   * @param {*} url 图片路径
   * @param {*} extent 图片四至
   * @return {void}
   */
  addImageLayer = (url: string, extent: number[]) => {
    const coorsOffset = new CoorsOffset();

    this.imageLayer = new AMap.ImageLayer({
      url,
      bounds: new AMap.Bounds(
        new AMap.LngLat(...coorsOffset.wgs84togcj02(extent[0], extent[1])),
        new AMap.LngLat(...coorsOffset.wgs84togcj02(extent[2], extent[3]))
      ),
      zooms: [5, 20,],
    });

    this.add(this.imageLayer);
  };

  // 图片图层设置图片
  setImageToImageLayer = (url: string) => {
    this.imageLayer.setImageUrl(url);
  };

  // 删除图片图层
  removeImageLayer = () => {
    const layers = this.getLayers();

    layers.forEach((layer: any) => {
      if (layer.CLASS_NAME === 'AMap.ImageLayer') {
        this.remove(layer);
      }
    });
  };

  showImageAtImageLayer = (url: string, extent: number[]) => {
    const coorsOffset = new CoorsOffset();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;

    // this.imageLayer 改为 tmpLayer,不然因为complete是异步导致快速切换图片时会出现个别图层实例丢失的情况
    const tmpLayer = new AMap.ImageLayer({
      url,
      bounds: new AMap.Bounds(
        new AMap.LngLat(...coorsOffset.wgs84togcj02(extent[0], extent[1])),
        new AMap.LngLat(...coorsOffset.wgs84togcj02(extent[2], extent[3]))
      ),
      opacity: this.imageOpacity ?? 0.6,
      zooms: [1, 20,],
    });

    this.imageLayer = tmpLayer;

    // 必须先加载完毕在清理，不然会有闪动的效果
    tmpLayer.on('complete', (e: any) => {
      if (that.img_layers_list.length > 0) {
        that.img_layers_list.forEach((a: any) => {
          // that.removeLayer(a);
          that.remove(a);
        });

        that.img_layers_list = [];
      }
      this.img_layers_list.push(tmpLayer);
    });

    this.add(this.imageLayer);

    // opacity为0时不会触发complete事件，所以这里手动清理图层
    if (this.imageOpacity === 0) {
      if (that.img_layers_list.length > 0) {
        that.img_layers_list.forEach((a: any) => {
          that.remove(a);
        });

        that.img_layers_list = [];
      }
      this.img_layers_list.push(tmpLayer);
    }
  };

  removeAllLayers () {
    this.removeLabelsLayer();
    this.removeImageLayer();
  }

  // 风场
  windLayerShow (windDatas: any) {
    this.windLayer.appendTo(this);
  }

  // 添加标记图层
  addTrackLabelsLayer = (): void => {
    this.trackLablesLayer = new AMap.LabelsLayer({
      zooms: [3, 20,],
      zIndex: 1000,
      collision: false,
    });
    this.add(this.trackLablesLayer);
  };

  // 地图清除标记图标
  clearTrackLabelsLayer = (): void => {
    if (Object.keys(this.trackLablesLayer).length) {
      this.trackLablesLayer.clear();
    }
  };

  // 地图删除trackLablesLayer图层
  removeTrackLabelsLayer = (): void => {
    if (Object.keys(this.trackLablesLayer).length) {
      this.remove(this.trackLablesLayer);
      // this.removeLayer(this.trackLablesLayer);
      this.trackLablesLayer = {};
      this.trackLableMarkers = {
        muckTrack: { car: {}, track: {}, },
        fogGunTrack: { car: {}, track: {}, },
        wateringTrack: { car: {}, track: {}, },
        sweeperTruck: { car: {}, track: {}, },
      };
    }
  };

  /*
   *  展示节点轨迹信息
   * trackInfos:节点信息
   * type：节点类型
   * trackType：轨迹类型(点、值)
   * callback：点击事件回调
   */
  showTrackNodesAtMap = (trackInfos: any, type: string ,trackType:'dot'|'value' = 'dot',indexType?:string,clickCallback?:any):void => {
    if (Object.keys(trackInfos).length === 0 || !trackInfos) {
      return;
    }

    const curCar = this.trackLableMarkers[type].showCar;

    Object.keys(trackInfos).forEach((key) => {
      // 轨迹节点
      const trackItems = trackInfos[key];

      if (Object.keys(trackItems).length === 0) {
        return;
      }

      const carMarkers: any = {};
      const trackMarkers: any = [];
      const startNode = trackItems[0];

      // 车牌
      const startTextMarker = new AMap.LabelMarker({
        name: `${key}_start`,
        position: [parseFloat(startNode.lon), parseFloat(startNode.lat),],
        zooms: [1, 20,],
        opacity: 1,
        anchor: 'center-center',
        zIndex: 12,
        icon: {
          type: 'image',
          image: icons[type].license,
          size: icons[type].licenseSize,
          offset: [0, 40,],
        },
        text: {
          content: key,
          offset: [0, 60,],
          style: {
            color: '#000',
            'font-size': '12px',
            'font-family': 'SourceHanSansCN-Medium',
          },
        },
      });

      const starMarker = new AMap.Marker({
        name: `${startNode.reportTime}_starMarker`,
        extData: startNode,
        position: [parseFloat(startNode.lon), parseFloat(startNode.lat),],
        icon: new AMap.Icon({
          image: icons[type].start,
          size: icons[type].size,
          imageSize: icons[type].iconSize,
          imageOffset: [-4, -4,],
        }),
        offset: [-3, -3,],
        zIndex: 30,
        clickable: true,
        angle: parseFloat(startNode.direction),
      });

      starMarker.on('click', (e: any) => {
        this.trackLableMarkers[type].showCar = key;
        this.trackMarkerHideOrRemove(type, 'hideAllExceptOne', key);

        startNode.position = e.lnglat;
        if (clickCallback) {
          clickCallback(startNode, type);
        }
      });

      startTextMarker.on('click', (e: any) => {
        this.trackLableMarkers[type].showCar = key;
        this.trackMarkerHideOrRemove(type, 'hideAllExceptOne', key);

        if (clickCallback) {
          clickCallback(startNode, type);
        }
      });

      carMarkers.startTextMarker = startTextMarker;
      carMarkers.starMarker = starMarker;

      // 遍历轨迹节点
      trackItems.forEach((trackNode: any) => {
        let trackMarkerIcon = null;

        switch (trackType) {
        case 'dot':
          trackMarkerIcon = new AMap.LabelMarker({
            name: trackNode.reportTime,
            position: [trackNode.lon, trackNode.lat,],
            zooms: [1, 20,],
            opacity: 0.4,
            zIndex: 10,
            offset: [-20, -20,],
            icon: {
              // 图标类型，现阶段只支持 image 类型
              type: 'image',
              image: icons[type].normal,
              // 图片尺寸
              size: [15, 15,],
            },
          });
          break;
        case 'value':
          if (!indexType) return;
          const indextype = indexType.toLowerCase();

          const markFeature = setFeatureThresholdInfo(trackNode[indextype], indextype);
          const value = markFeature.eleValue;
          const ValueText = (value && value !== '-9999' && value !== '999999') || value === '0' ?
            parseFloat(Number(value).toFixed(2)) :
            '-';

          trackMarkerIcon = new AMap.LabelMarker({
            name: trackNode.time,
            position: [trackNode.lon, trackNode.lat,],
            zooms: [1, 20,],
            opacity: 0.6,
            zIndex: 10,
            icon: {
              type: 'image',
              image: icons[type][markFeature.emo],
              // 图片尺寸
              size: icons[type].iconSize,
            },
            text: {
              content: String(ValueText),
              offset: [0, 27,],
              style: {
                color: '#000',
                'font-size': '22px',
                'font-family': 'SourceHanSansCN-Medium',
              },
            },
          });
          break;
        default:
          break;
        }

        trackMarkers.push(trackMarkerIcon);
      });

      this.trackLableMarkers[type].car[key] = carMarkers;
      this.trackLableMarkers[type].track[key] = trackMarkers;

      /*
       * 将 trackMarkers 添加到图层
       */
      this.add(starMarker);
      this.trackLablesLayer.add(this.trackLableMarkers[type].car[key].startTextMarker);
      this.trackLablesLayer.add(this.trackLableMarkers[type].track[key]);
    });

    // 隐藏除当前车辆外的其他车辆轨迹
    if (curCar) {
      this.trackMarkerHideOrRemove(type,'hideAllExceptOne', curCar);
    }
  };

  /*
   *  隐藏或隐藏trackMakers
   * trackType:trackMake的类型
   * handleType:操作类型  hide remove
   */
  trackMarkerHideOrRemove = (trackType: string, handleType: string, nodeKey: string) => {
    if (handleType === 'all') {
      Object.keys(this.trackLableMarkers).forEach((type: string) => {
        this.trackMarkerHideOrRemove(type,'remove','');
      });

      return;
    }
    if (!this.trackLableMarkers[trackType]) {
      return;
    }
    const trackLableMarkers = this.trackLableMarkers[trackType].track;
    const carLableMarkers = this.trackLableMarkers[trackType].car;

    switch (handleType) {
    case 'hide':
      Object.keys(trackLableMarkers).forEach((key) => {
        trackLableMarkers[key].forEach((trackNode: any) => {
          trackNode.hide();
        });
      });
      break;
    case 'remove':

      Object.keys(trackLableMarkers).forEach((key) => {
        const trackItems = trackLableMarkers[key];

        trackItems.forEach((trackNode: any) => {
          trackNode.remove();
        });
      });
      Object.keys(carLableMarkers).forEach((key) => {
        const startTextMarker = carLableMarkers[key].startTextMarker;
        const starMarker = carLableMarkers[key].starMarker;

        startTextMarker.remove();
        this.remove(starMarker);
      });
      this.trackLableMarkers[trackType].track = {};
      this.trackLableMarkers[trackType].car = {};
      if (nodeKey !== 'remainKey') {
        this.trackLableMarkers[trackType].showCar = '';
      }
      break;
    case 'hideAllExceptOne':
      Object.keys(this.trackLableMarkers).forEach((carKey: string) => {
        Object.keys(this.trackLableMarkers[carKey].track).forEach((typekey: string) => {
          // eslint-disable-next-line no-negated-condition
          if (typekey !== nodeKey) {
            const trackItems = this.trackLableMarkers[carKey].track[typekey];

            trackItems.forEach((trackNode: any) => {
              trackNode.hide();
            });
          } else {
            const trackItems = this.trackLableMarkers[carKey].track[typekey];

            trackItems.forEach((trackNode: any) => {
              trackNode.show();
            });
          }
        });
      });
      //  this.trackLablesLayer.add(this.trackLableMarkers[trackType].track[nodeKey]);
      break;
    default:
      break;
    }
  };

  // 创建信息窗体实例
  addInfoWin = (content: HTMLElement, offset: number[], anchor = 'top-left') => {
    this.infoWin = null;
    this.infoWin = new AMap.InfoWindow({
      isCustom: true,
      // autoMove: true,
      content,
      anchor,
      offset: new AMap.Pixel(...offset),
    });
  };

  // 展示&关闭弹窗
  showInfoWin = (isOpen: boolean, position?: any) => {
    if (!this.infoWin) {
      return;
    }

    if (isOpen) {
      this.infoWin.open(this, position);
    } else {
      this.infoWin.close();
      // 取消站点选中效果
      if (this.selectedStation.marker) {
        this.selectedStation.marker.setContent(this.selectedStation.contentHTml);
      }
      this.selectedStation.id = '';
      this.selectedStation.marker = null;
      this.selectedStation.contentHTml = '';
    }
  };

  // 设置选中站点（聚合图层）
  setSelectedStation = (nodeType: string, name: string, id: string): void => {
    if (this.selectedStation.marker) {
      this.selectedStation.marker = null;
    }
    this.selectedStation.id = nodeType + name + id ?? '';
  }

  removeWmsLayers = () => {
    const layers = this.getLayers();

    layers.forEach((layer: any) => {
      if (layer.CLASS_NAME === 'AMap.TileLayer.WMS') {
        this.remove(layer);
      }
    });
  };

  // 添加wms图层
  addWmsLayer = (layer: string, layerName: string, type?: number): any => {
    if (!this.wmsLayer[layerName] || Object.keys(this.wmsLayer[layerName]).length) {
      this.removeLayer(this.wmsLayer[layerName]);
      this.wmsLayer[layerName] = {};
    }
    this.wmsLayer[layerName] = new AMap.TileLayer.WMS({
      url: geoserverIp,
      params: {
        LAYERS: layer,
        VERSION: '1.1.0',
        blend: false,
      },
      zIndex: 1,
    });
    this.add(this.wmsLayer[layerName]);
  };

  showImageAtImageLayerContrast = (url: string, extent: number[]) => {
    const coorsOffset = new CoorsOffset();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;

    this.imageLayer = new AMap.ImageLayer({
      url,
      bounds: new AMap.Bounds(
        new AMap.LngLat(...coorsOffset.wgs84togcj02(extent[0], extent[1])),
        new AMap.LngLat(...coorsOffset.wgs84togcj02(extent[2], extent[3]))
      ),
      opacity: 0.6,
      zooms: [1, 20,],
    });

    this.add(this.imageLayer);
  };

  // url 图片地址 是否isfirst第一次加载
  CanvasLdImg = (url: string, extent: number[]) => {
    // 创建canvas
    const canvas = document.createElement('canvas');

    /*
     * canvas.width = 5717;
     * canvas.height = 4837;
     */
    this.context = canvas.getContext('2d');

    // 创建图片
    this.canvaimg = new Image();
    // 跨域 调用的接口是有其他IP的图片地址
    this.canvaimg.setAttribute('crossOrigin','Anonymous');
    this.canvaimg.src = url;

    // onload方法，图片加载完毕，再调用drawImage
    this.canvaimg.onload = () => {
      const width = this.canvaimg.width;

      const height = this.canvaimg.height;

      this.context.width = this.canvaimg.width;
      this.context.height = this.canvaimg.height;
      // 清理

      this.context.clearRect(0, 0, width, height);
      this.context.drawImage(this.canvaimg, 0, 0, width, height, 0, 0, width, height);
    };

    // 创建CanvasLayer图层
    const CanvasLayer = new AMap.CanvasLayer({
      canvas,
      bounds: new AMap.Bounds(
        [extent[0],extent[1],],[extent[2],extent[3],]
      ),
      zooms: [1, 20,],
      opacity: 0.7,
      zIndex: 100,
    });

    this.img_layers_list.push(CanvasLayer);
    this.addLayer(CanvasLayer);
  };

  clearMarkIconAllByType = (nodeType: string) => {
    this.clusterLayer[nodeType].setMap(null);
    this.clusterLayer[nodeType] = {};
  };

  // 将某一种类型markers全部设置为初始化图标
  resMarkIconAllByType = (nodeType: string) => {
    if (!this.clusterLayer.satellitePoint.U || this.clusterLayer.satellitePoint.U.length === 0) {
      return;
    }
    const cmarks = this.clusterLayer.satellitePoint.U;
    const topOffset = icons[nodeType].topOffset ?? '0';
    const iconSize = icons[nodeType].iconSize ?? [45,47,];
    const contentNoChecked = `<div><div style="z-index:0;margin:auto;position:relative;text-align:center;background-image: url(${icons[nodeType].normal});background-size: 100% 100%;background-repeat: no-repeat;font-size:14px;line-height:${iconSize[1]}px;color: 'rgb(68, 67, 0)'; height: ${iconSize[1]}px; width: ${iconSize[0]}px; padding-top:${topOffset};z-index:0;">${''}</div></div>`;

    cmarks.forEach((cmarker: any) => {
      if (cmarker.id === this.selectedStation.id) {
        cmarker.setContent(contentNoChecked);
        cmarker.setzIndex(0);
        this.selectedStation.id = '';
        this.selectedStation.marker = null;
        this.selectedStation.contentHTml = '';
      }
    });
  };

  // 通过markerId 将图片换成高亮，并居中
  setMarkIconHighLight = (nodeType: string, markerId: string, pos: any) => {
    this.resMarkIconAllByType(nodeType);

    const cmarks = this.clusterLayer.satellitePoint.U;
    const topOffset = icons[nodeType].topOffset ?? '0';
    const iconSizeHigh = icons[nodeType].iconSizeHigh ?? [45,49,];
    const contentCheckedIcon = `<div><div style="z-index:20;margin:auto;position:relative;text-align:center;background-image: url(${icons[nodeType].high});background-size: 100% 100%;background-repeat: no-repeat;font-size:14px;line-height:${iconSizeHigh[1]}px;color: 'rgb(68, 67, 0)'; height: ${iconSizeHigh[1]}px; width: ${iconSizeHigh[0]}px; padding-top:${topOffset};">${''}</div></div>`;

    cmarks.forEach((cmarker: any, index: number) => {
      if (cmarker.id === markerId) {
        cmarks[index].setzIndex(20);
        cmarks[index].setContent(contentCheckedIcon);
        this.setCenter(pos);
        this.selectedStation.marker = cmarker;
        this.selectedStation.contentHTml = contentCheckedIcon;
        this.selectedStation.id = markerId;
      }
    });
  };

  /**
   * 绘制溯源轨迹及点
   * @param {any[]} data 轨迹路径数据
   * @param {string} strokeColor 颜色
   * @param {string} traceOverlayGroup overlay名称
   * @return {void}
   */
  drawPolyLine = (data:any[], strokeColor: string, traceOverlayGroup: string) => {
    if (data.length === 0) return;
    if (Object.keys(this.traceLayer[traceOverlayGroup]).length) {
      this.traceLayer[traceOverlayGroup].removeOverlays([...this.traceMarkers, this.polyLinePath,]);
      this.remove(this.traceLayer[traceOverlayGroup]);
      this.polyLinePath = {};
      this.traceLayer[traceOverlayGroup] = {};
      this.traceMarkers = [];
    }

    const path = data.map((i) => [Number(i.lon), Number(i.lat),]);

    // 绘制溯源轨迹
    this.polyLinePath = new AMap.Polyline({
      path,
      showDir: true,
      dirColor: 'white',
      // 线颜色
      strokeColor,
      strokeWeight: 8,
      strokeOpacity: 1,
      lineJoin: 'round',
      lineCap: 'round',
    });

    const positions = data.slice(0, data.length - 1);

    // 普通点-溯源点信息弹窗
    const normalMarker = new AMap.Marker({
      anchor: 'bottom-left',
      offset: [0, -15,],
    });

    for (let i = 0; i < positions.length; i++) {
      const CircleMarker = new AMap.CircleMarker({
        center: [Number(positions[i].lon), Number(positions[i].lat),],
        fillColor: strokeColor,
        fillOpacity: 1,
        strokeColor,
        radius: 5,
        cursor: 'pointer',
      });

      // 给marker绑定事件
      CircleMarker.on('mouseover', (e: any) => {
        const position = e.lnglat;

        CircleMarker.setOptions({
          strokeColor: '#fff',
          strokeWeight: 4,
          strokeOpacity: 1,
          radius: 7,
        });

        if (position) {
          normalMarker.setContent(
            `<div
            style="font-size: 14px; background-color: #fff; padding: 10px; box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.2000); border-radius: 4px 4px 4px 0px;white-space:nowrap;">
            ${moment(positions[i].pointIssue, 'YYYYMMDDhhmm').format('YYYY年MM月DD日HH时')}
            <div style="text-align: left">${positions[i].height}m</div>` +
            `</div>`
          );
          normalMarker.setPosition(position);
          this.add(normalMarker);
        }
      });

      CircleMarker.on('mouseout', () => {
        CircleMarker.setOptions({
          strokeColor,
          strokeWeight: 2,
          strokeOpacity: 0.9,
          radius: 5,
        });
        this.remove(normalMarker);
      });

      // this.add(CircleMarker);

      this.traceMarkers.push(CircleMarker);
    }

    // 创建一个 Icon
    const icon = new AMap.Icon({
      // 图标尺寸
      size: new AMap.Size(19, 40),
      // 图标的取图地址
      image: './static/data/icon/trace/end.png',
      // 图标所用图片大小
      imageSize: new AMap.Size(19, 40),
      imageOffset: [0, 0,],
    });

    const endMarker = new AMap.Marker({
      position: [data[data.length - 1].lon, data[data.length - 1].lat,],
      anchor: 'bottom-left',
      icon,
      offset: [-7, 0,],
    });

    this.traceMarkers.push(endMarker);

    // 给溯源marker绑定事件
    endMarker.on('mouseover', (e: any) => {
      const position = e.lnglat;

      if (position) {
        normalMarker.setContent(
          `<div
            style="font-size: 14px; background-color: #fff; padding: 10px; box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.2000); border-radius: 4px 4px 4px 0px;white-space:nowrap;">
            ${moment(data[data.length - 1].pointIssue, 'YYYYMMDDhhmm').format('YYYY年MM月DD日HH时')}` +
            `</div>`
        );
        normalMarker.setPosition(position);
        this.add(normalMarker);
      }
    });

    endMarker.on('mouseout', () => {
      this.remove(normalMarker);
    });

    this.traceLayer[traceOverlayGroup] = new AMap.OverlayGroup([this.polyLinePath,...this.traceMarkers,]);

    this.add(this.traceLayer[traceOverlayGroup]);

    // 注释setFitView，增加setCenter，以当前默认溯源点位置为地图中心（产品要求）
    this.setCenter([data[data.length - 1].lon, data[data.length - 1].lat,]);
    // this.setFitView(this.polyLinePath);
  }

  drawHotGrid = (gridData: any, callback: any) => {
    this.removeNudation();
    const textList :any = [];

    const addPixel = (info: any) => {
      if (!info) {
        return;
      }
      const {
        lon, lat, id,value, cFeature,
      } = info;

      if (lon === '9999' || lat === '9999') {
        return;
      }

      // 0.5 * 0.5
      const deviationX = 0.005 / 2;
      const deviationY = 0.005 / 2;

      // 左下角定位
      const southWestPath = [parseFloat(lon) - deviationX, parseFloat(lat) - deviationY,];
      // 右上角定位
      const northEastPath = [parseFloat(lon) + deviationX, parseFloat(lat) + deviationY,];

      const southWest = new AMap.LngLat(...southWestPath);
      const northEast = new AMap.LngLat(...northEastPath);

      const bounds = new AMap.Bounds(southWest, northEast);
      const bgColor = colorMap[cFeature]?.bgColor ?? '#F31414';

      const rectangle = new AMap.Rectangle({
        bounds,
        strokeColor: bgColor,
        strokeWeight: 2,
        strokeOpacity: 1,
        strokeDasharray: [30,10,],
        // strokeStyle还支持 solid
        strokeStyle: 'solid',
        fillColor: bgColor,
        fillOpacity: 0.2,
        cursor: 'pointer',
        zIndex: 50,
        extData: {
          id,
        },
      });

      // 添加文字
      const text = new AMap.Text({
        text: value ?? '--',
        zooms: [14, 20,],
        anchor: 'center',
        style: {
          'background-color': 'transparent',
          'border-width': 0,
          'font-size': '14px',
          'font-weight': 'bold',
          color: '#fff',
        },
        position: [parseFloat(lon), parseFloat(lat),],
      });

      textList.push(text);

      const flag = true;

      rectangle.on('click', (data: any) => {
        this.rectangles.forEach((item: any) => {
          item.setOptions({
            fillOpacity: 0.2,
          });
        });

        rectangle.setOptions({
          fillOpacity: 1,
        });

        callback(info);
      });

      this.rectangles.push(rectangle);

      // this.add(rectangle);

      // 缩放地图到合适的视野级别

      if (gridData.length > 1) {
        this.setFitView(this.rectangles, false, [60,
          135,
          60,
          60,]);
      } else {
        this.setZoom(12);
        this.setCenter([gridData[0].lon,gridData[0].lat,]);
      }
    };

    gridData.forEach((item: any) => {
      addPixel(item);
    });

    this.gridOverlayGroups = new AMap.OverlayGroup(this.rectangles);
    this.gridOverlayGroups.addOverlays(textList);

    this.add(this.gridOverlayGroups);
  };

  drawNudation = (gridData: any, callback: any) => {
    this.removeHotGrid();

    const addPixel = (info: any) => {
      if (!info) {
        return;
      }
      const { bounds, index, } = info;

      // const bounds = new AMap.Bounds(southWest, northEast);

      const polygon = new AMap.Polygon({
        path: bounds,
        fillColor: '#F31414',
        strokeOpacity: 1,
        fillOpacity: 0.4,
        strokeColor: '#F31414',
        strokeWeight: 2,
        strokeStyle: 'solid',
        strokeDasharray: [5, 5,],
        extData: {
          id: index,
        },
      });

      const flag = true;

      polygon.on('click', (data: any) => {
        this.rectangles.forEach((item: any) => {
          item.setOptions({
            fillOpacity: 0.2,
          });
        });

        polygon.setOptions({
          fillOpacity: 1,
        });

        callback(polygon);
      });

      this.rectangles.push(polygon);

      // this.add(rectangle);

      // 缩放地图到合适的视野级别

      if (gridData.length > 1) {
        this.setFitView(this.rectangles, false, [60,
          60,
          600,
          600,]);
      } else {
        this.setZoom(12);
        this.setCenter([gridData[0].lon,gridData[0].lat,]);
      }
    };

    gridData.forEach((item: any) => {
      addPixel(item);
    });

    this.gridOverlayGroups = new AMap.OverlayGroup(this.rectangles);

    this.add(this.gridOverlayGroups);
  };

  removeHotGrid = () => {
    if (Object.keys(this.gridOverlayGroups).length) {
      this.remove(this.gridOverlayGroups);
      this.gridOverlayGroups = {};
      this.rectangles = [];
    }
  };

  removeNudation = () => {
    if (Object.keys(this.gridOverlayGroups).length) {
      this.remove(this.gridOverlayGroups);
      this.gridOverlayGroups = {};
      this.rectangles = [];
    }
  };

  // 经纬度 ——> 地址
  geocoder = (lnglat: any, callback: any) => {
    AMap.plugin(['AMap.Geocoder',],() => {
      new AMap.Geocoder({
        extensions: 'all',
      }).getAddress(lnglat, (status: any, result: any) => {
        if (status === 'complete' && result.regeocode) {
          const address = result.regeocode.formattedAddress;

          return callback(address);
        }
        message.error('根据经纬度查询地址失败');
      });
    });
  }

  /*
   *  展示扇形
   * markInfo：基站基本信息
   * radius：半径范围
   * windDirection:初始风向角度（度数）
   * leftAngle,rightAngle扇形两边夹角度数
   * 注意：一个圆形区域分为两个扇形：1、有fill填充的扇形sectorStroke 2、无fill填充的扇形sectorNoStroke
   * 由sectorStroke、sectorNoStroke两个扇形组成一个圆
   */
  showSector = (markInfo: any, radius:number,windDirection:number,leftAngle:number,rightAngle:number,callback: any) => {
    this.removeSector();

    /*
     * 这三个参数
     * radian1：有fill填充的扇形 左边夹角
     * radian2：有fill填充的扇形 右边夹角
     * radian2：无fill填充的扇形 左边夹角
     * radian3：无fill填充的扇形 右边夹角
     */
    const radian1 = windDirection - 90 - leftAngle;
    const radian2 = windDirection - 90 + rightAngle;
    //  const radian3 = radian1 >= 0 ? radian1 : 360 + radian1;
    const radian3 = radian1 + 360;
    const pos = new AMap.LngLat(markInfo.lon,markInfo.lat);

    // 有fill填充的扇形
    const sectorStroke = new AMap.Polygon({
      path: this.drawSector(pos, radius, radian1, radian2,callback),
      strokeColor: '#ff0000',
      strokeOpacity: '1',
      strokeWeight: 1,
      fillColor: '#ff0000',
      fillOpacity: '0.3',
    });

    // 无fill填充的扇形
    const sectorNoStroke = new AMap.Polygon({
      path: this.drawSector(pos, radius, radian2,radian3,callback),
      strokeColor: '#00AAFF',
      strokeOpacity: '1',
      strokeWeight: 1,
      fillColor: '#00AAFF',
      fillOpacity: '0.1',
    });

    /*
     * 现在没有点击事件，所以屏蔽掉
     * sectorStroke.on('click', callback);
     * sectorNoStroke.on('click', callback);
     */
    this.sectorLayer.sectorNoStroke = sectorNoStroke;
    this.add(sectorNoStroke);

    this.sectorLayer.sectorStroke = sectorStroke;
    this.add(sectorStroke);
  }

  removeSector =() => {
    if (this.sectorLayer.sectorStroke) {
      this.remove(this.sectorLayer.sectorStroke);
    }
    if (this.sectorLayer.sectorNoStroke) {
      this.remove(this.sectorLayer.sectorNoStroke);
    }
  }

  /*
   *  计算扇形形状
   * position:经纬度
   * radius：半径范围
   * radian1:扇形左边角度
   * radian2：扇形右边边角度
   */
  drawSector = (position:any, radius:number, radian1:number, radian2:number,callback:any) => {
    // 这个数字越大，扇形边界越圆润
    const circularCount = 30;
    const points = [];
    // 根据扇形的总夹角确定每步夹角度数，最大为10

    const step = ((radian2 - radian1) / circularCount) || circularCount;

    points.push(position);
    // 循环获取每步的圆弧上点的坐标，存入点数组
    for (let i = radian1; i < radian2 + 0.001; i += step) {
      points.push(this.eOffsetBearing(position, radius, i));
    }
    points.push(position);

    return points;
  }

  /**
   * 计算扇形坐标
   * position:经纬度
   * radius：半径范围
   * bearing:点位
   */
  eOffsetBearing=(position:any, radius:number, bearing:number) => {
    // 计算1纬度与原点的距离
    const lngConv = position.distance(new AMap.LngLat(position.getLng() + 0.1, position.getLat())) * 10;
    const latConv = position.distance(new AMap.LngLat(position.getLng(), position.getLat() + 0.1)) * 10;
    // 正弦计算待获取的点的纬度与原点纬度差
    // eslint-disable-next-line no-mixed-operators
    const lat = radius * Math.sin(-bearing * Math.PI / 180) / latConv;
    // 余弦计算待获取的点的经度与原点经度差
    const lng = radius * Math.cos(-bearing * Math.PI / 180) / lngConv;

    return new AMap.LngLat(position.getLng() + lng, position.getLat() + lat);
  }

  /**
   * 删除临时点位
   */
  removeTempMarker = () => {
    if (Object.keys(this.tempMarker.marker).length) {
      this.remove(this.tempMarker.marker);
      this.tempMarker.marker = {};
    }
  };

  /**
   * @desc 生成点位信息并根据鼠标移动点位
   * @param content 提示信息
   */
  createAnimationMarker = (content: string) => {
    if (content) {
      this.tempMarker.animationMarker = new AMap.Marker({
        content: `<div style="font-size: 14px; background-color: #fff; padding: 10px; box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.2000); border-radius: 4px 4px 4px 0px;white-space:nowrap;">${content}</div>`,
        map: this,
        offset: new AMap.Pixel(5, 5),
      });

      // 地图添加move的鼠标事件监听
      this.on('mousemove', this.tempMarkerInfoWinAnimate);
    }
  };

  /**
   * @desc 鼠标移动 提示信息窗口随之移动
   * @param {HthtAMap.MapsEvent} e 地图事件实例
   */
  tempMarkerInfoWinAnimate = (e: HthtAMap.MapsEvent) => {
    this.tempMarker.animationMarker.setPosition(e.lnglat);
    AMap.plugin('AMap.MoveAnimation', () => {
      // 加载完 AMap.MoveAnimation 插件以后，创建一个 Marker 实例，调用 moveTo 方法
      this.tempMarker.animationMarker.moveTo(e.lnglat, {
        duration: 0,
        delay: 0,
        autoRotation: false,
      });
    });
  };

  /**
   * @desc 鼠标点击事件 创建临时点位
   * @param {string} markerIcon marker的图片资源
   * @param {HthtAMap.MapsEvent} e 高德地图地图事件对象
   */
  handleCreateTempMarker = (markerIcon: string, e: HthtAMap.MapsEvent) => {
    // 删除提示信息 并且取消mousemove事件监听
    this.handleRemoveTempMarkerEventStrategies('mousedown')();
    // 缓存鼠标点击的经纬度
    this.tempMarker.lnglatAddress.lnglat = e.lnglat;
    // 缓存鼠标点击的位置
    this.geocoder(e.lnglat, (address: any) => {
      this.tempMarker.lnglatAddress.address = address;
      // 设置被观察对象的状态
      this.tempMarker.observedInstance.setState(this.tempMarker.lnglatAddress);
      // 向所有观察者广播
      this.tempMarker.observedInstance.notify();
    });

    const icon = new AMap.Icon({
      size: new AMap.Size(19, 40),
      image: markerIcon,
      imageSize: new AMap.Size(19, 40),
      imageOffset: [0, 0,],
    });

    // 缓存临时marker
    this.tempMarker.marker = new AMap.Marker({
      map: this,
      position: e.lnglat,
      anchor: 'top-left',
      icon,
      offset: [-5, 5,],
    });
  };

  /**
   * @desc 取消事件监听策略
   * @param {string} type mousedown|mouseup|esc
   * @returns {Function} 返回取消事件监听的函数
   */
  handleRemoveTempMarkerEventStrategies = (type: string) => {
    const strategies = {
      mousedown: () => {
        this.remove(this.tempMarker.animationMarker);
        this.off('mousemove', this.tempMarkerInfoWinAnimate);
      },
      mouseup: () => {
        this.off('click', this.handleCreateTempMarker);
        this.setDefaultCursor('default');
      },
      esc: () => {
        strategies.mousedown();
        strategies.mouseup();
      },
    };
    const noop = () => {}; // 禁止莫名其妙的type类型解绑事件监听

    return strategies[type] ? strategies[type] : noop;
  };

  /**
   * @desc 点击生成marker点位
   * @param {string} moveContent 鼠标move过程的提示信息
   * @param {string} markerIcon 鼠标click时生成marker的图片资源
   * @param ...args icon大小等 视情况进行调整局部代码
   */
  createMarkerByClick = ({ moveContent, markerIcon, watchInstance, }: Record<string, string|Watch>) => {
    // 绑定观察者
    this.tempMarker.observedInstance.add(watchInstance);
    // 删除临时点位
    this.removeTempMarker();
    // 设置鼠标
    this.setDefaultCursor('pointer');
    // 如果有提示信息，则生成marker并移动提示信息
    this.createAnimationMarker(moveContent as string);
    // 点击地图 生成临时marker
    this.on('click', (e: any) => this.handleCreateTempMarker(markerIcon as string, e));
    // 监听鼠标up时 取消事件监听
    this.on('mouseup', this.handleRemoveTempMarkerEventStrategies('mouseup'));
    // 监听鼠标右键 取消事件监听
    this.on('rightclick', this.handleRemoveTempMarkerEventStrategies('esc'));
    // 监听键盘esc 取消事件监听
    window.onkeydown = (e: any) => {
      if (e.key === 'Escape') {
        this.handleRemoveTempMarkerEventStrategies('esc')();
      }
    };
  }

  // 地图工具条-初始化
  addMouseTool = () :void => {
    this.mouseTool = null;
    this.plugin(['AMap.MouseTool',],() => {
      this.mouseTool = new AMap.MouseTool(this);
      const clearOverlayGroup = new AMap.OverlayGroup();

      clearOverlayGroup.setMap(this);

      this.mouseTool.on('draw', (ev :any) => {
        if (ev.obj.CLASS_NAME === 'Overlay.Polyline') {
          // 手动获取每个关闭和叉图标，设置不可见
          const ele:any = document.getElementsByClassName('delimg');
          const delNode:any = document.getElementsByClassName('deleteNode');

          for (let i = 0; i < ele.length; i++) {
            ele[i].style.display = 'none';
          }
          for (let i = 0; i < delNode.length; i++) {
            delNode[i].style.display = 'none';
          }
        }
        // 高德提供的面积测量工具没有删除功能，所以自己添加一个
        if (ev.obj.CLASS_NAME === 'Overlay.Polygon') {
          // eslint-disable-next-line no-underscore-dangle
          const id = ev.obj._amap_id;
          const position = ev.obj.getPath().slice(-1)[0];
          const delMarker = new AMap.Marker({
            position,
            icon: new AMap.Icon({
              size: [20,20,],
              image: 'https://webapi.amap.com/images/destroy.png',
              imageSize: [20,20,],
              imageOffset: [0, 0,],
            }),
            offset: new AMap.Pixel(-30, 7),
          });

          delMarker.on('click', (e:any) => {
            // eslint-disable-next-line no-underscore-dangle
            const idx = this.mouseTool.overlays.measureArea.findIndex((i:any) => i._amap_id === id);

            // 清除面积区域Polygon及测量数据text
            this.remove([...this.mouseTool.overlays.measureArea.slice(idx - 1,idx + 1),]);
            // 清除对应的‘删除图标’
            clearOverlayGroup.removeOverlay(delMarker);
          });
          clearOverlayGroup.addOverlay(delMarker);
        }
        this.mouseTool.close(false);
      });
    });
  }

  // 测距并画圆
  distancedAndCircle = () => {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    const p1 = this.lineMarker[0].getPosition();
    const p2 = this.lineMarker[1].getPosition();
    // const textPos = p1.divideBy(2).add(p2.divideBy(2));
    const distance = Math.round(p1.distance(p2));
    const path = [p1,p2,];

    const line = new AMap.Polyline({
      strokeColor: '#1664ff',
      isOutline: true,
      outlineColor: 'white',
    });

    const tmpValue = this.tmpElementsMap.get(this.keyMap[this.keyMap.length - 1]) || [];

    tmpValue.push(line);

    this.tmpElementsMap.set(this.keyMap[this.keyMap.length - 1], tmpValue);

    const ruleCircle = new AMap.Circle({
      center: [that.linePoint[0].lng,that.linePoint[0].lat,],
      radius: distance,
    });

    const tmpValue2 = this.tmpElementsMap.get(this.keyMap[this.keyMap.length - 1]) || [];

    tmpValue2.push(ruleCircle);

    this.tmpElementsMap.set(this.keyMap[this.keyMap.length - 1], tmpValue2);

    line.setPath(path);
    line.setMap(that);
    // text.setText(`两点距离${(distance / 1000).toFixed(2)}公里`);
    // text.setPosition(textPos);
    // text.setMap(that);
    ruleCircle.setMap(that);
  }

  // 自定义测距产生的marker（自身测距行为已被关闭）
  customCreatMarkerByRule = () => {
    this.linePoint.forEach((item:any) => {
      const { lng,lat, } = item;
      const marker = new AMap.Marker({
        map: this,
        // 自定义图标并设置offset，不然marker有偏移
        icon: new AMap.Icon({
          size: [20,25,],
          image: 'https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
          imageSize: [20,25,],
          imageOffset: [0, 0,],
        }),
        position: new AMap.LngLat(lng, lat),
        offset: new AMap.Pixel(-10, -17),
      });

      this.lineMarker.push(marker);
      const tmpValue = this.tmpElementsMap.get(this.keyMap[this.keyMap.length - 1]) || [];

      tmpValue.push(marker);

      this.tmpElementsMap.set(this.keyMap[this.keyMap.length - 1], tmpValue);
    });

    // 测距并画圆
    this.distancedAndCircle();

    // 生成删除图标并注册删除事件
    const delMarker = new AMap.Marker({
      map: this,
      position: this.lineMarker[1].getPosition(),
      icon: new AMap.Icon({
        size: [20,20,],
        image: 'https://webapi.amap.com/images/destroy.png',
        imageSize: [20,20,],
        imageOffset: [0, 0,],
      }),
      // offset: new AMap.Pixel(-30, 7),
    });

    // delMarkerId与当前this.keyMap最后一个元素对应，用来删除指定的临时元素集合
    delMarker.setExtData({ delMarkerId: this.keyMap[this.keyMap.length - 1], });

    const tmpValue = this.tmpElementsMap.get(this.keyMap[this.keyMap.length - 1]) || [];

    tmpValue.push(delMarker);

    this.tmpElementsMap.set(this.keyMap[this.keyMap.length - 1], tmpValue);

    delMarker.on('click', () => {
      const key = delMarker.getExtData().delMarkerId;

      const removeList = this.tmpElementsMap.get(key);

      removeList.forEach((item:any) => {
        this.remove(item);
      });
    });
  };

  // 实时显示鼠标距离第一个点位的距离
  showDistanceOnMouseMove = (e:any) => {
    if (!this.tmpLineText || this.addLineTextFlag) {
      this.tmpLineText = new AMap.Text({
        text: '',
        style: {
          'background-color': '#fff',
          'font-size': '16px',
        },
      });
      this.addLineTextFlag = false;
      const tmpValue = this.tmpElementsMap.get(this.keyMap[this.keyMap.length - 1]) || [];

      tmpValue.push(this.tmpLineText);

      this.tmpElementsMap.set(this.keyMap[this.keyMap.length - 1], tmpValue);
    }

    const p1 = new AMap.LngLat(this.linePoint[0].lng,this.linePoint[0].lat);
    const p2 = e.lnglat;
    const distance = Math.round(p1.distance(p2));

    this.tmpLineText.setText(`距离${(distance / 1000).toFixed(2)}公里`);
    this.tmpLineText.setPosition(p2);
    this.tmpLineText.setMap(this);
  };

  // 监听地图点击事件
  watchMapClick = () => {
    // 销毁之前的点击事件并清空存储的点
    this.clearEvents('click');
    this.linePoint = [];
    this.lineMarker = [];
    this.addLineTextFlag = true;

    this.on('click', (e:any) => {
      if (this.linePoint.length === 2) {
        this.addLineTextFlag = false;

        return;
      }
      const lng = e.lnglat.getLng();
      const lat = e.lnglat.getLat();

      this.linePoint.push({
        lng,
        lat,
      });

      // 点下第一个点后，开启鼠标监听，实时显示距离
      if (this.linePoint.length === 1) {
        this.on('mousemove',this.showDistanceOnMouseMove);
      }

      if (this.linePoint.length === 2) {
        this.customCreatMarkerByRule();
        this.mouseTool.close(true);
        this.addLineTextFlag = false;
        this.clearEvents('mousemove');
        this.setDefaultCursor('default');
      }
    });
  };

  // 地图工具-使用
  handleMouse = (type:string,opts?:any) :void => {
    if (!this.mouseTool) return;
    switch (type) {
    case 'rule':
      this.keyMap.push(`rule-key-${this.keyMap.length}`);
      this.watchMapClick();
      this.mouseTool.rule();
      this.setDefaultCursor('pointer');
      break;
    case 'measureArea':
      this.mouseTool.measureArea();
      break;
    case 'close':
      this.mouseTool.close(true);
      break;
    default:
      break;
    }
  }

  // 设置图片图层透明度
 setImageOpacity = (opacity: number) :void => {
   if (opacity < 0 || opacity > 1) return;
   this.imageOpacity = opacity ?? 0.6;
 }
}
